import { styled, Box } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const DownloadBannerCont = styled(Box)(({ theme }) => ({
  borderStyle: 'solid',
  borderWidth: '2px',
  // borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
  border: `1px solid ${COLORS.PRIMARY}`,
  borderImageSlice: '1',
  backgroundImage:
    theme.palette.type === 'dark'
      ? 'linear-gradient(to bottom, #0c0f14, #0c0f14), linear-gradient(253deg, #d51bff, #00d4ff)'
      : `linear-gradient(to bottom, ${COLORS.LIGHT}, ${COLORS.LIGHT}), linear-gradient(253deg, #d51bff, #00d4ff)`,
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '8px !important',
}));

export const DownloadCont = styled(Box)(({ theme }) => ({
  margin: 10,
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const AdsImg = styled('img')(({ theme }) => ({
  width: 80,
  height: 100,
  marginRight: 10,
  [theme.breakpoints.down(960)]: {
    marginBottom: 10,
  },
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  display: ' flex',
  gap: 10,
  [theme.breakpoints.down(1200)]: {
    marginTop: 10,
    marginLeft: 'unset',
    flexDirection: 'column',
    gap: 'unset',
  },
}));
